import { apiRequest } from './apiClient';

export async function fetchBakimFiyatlari(params = {}) {
  const query = {};
  if (params.arama) query.arama = params.arama;
  if (params.aktif != null) query.aktif = params.aktif;
  if (params.sayfa) query.sayfa = params.sayfa;
  if (params.limit) query.limit = params.limit;
  if (params.kategoriId) query.kategoriId = params.kategoriId;
  if (params.kategoriAgaciDahil) query.kategoriAgaciDahil = 'true';
  return apiRequest('/api/bakim-fiyatlari', { method: 'GET', query });
}

export async function updateBakimFiyati(icerikId, payload) {
  return apiRequest(`/api/bakim-fiyatlari/${icerikId}`, {
    method: 'PATCH',
    body: payload,
  });
}

export async function updateBakimFiyatiToplu(payload) {
  return apiRequest('/api/bakim-fiyatlari/toplu', {
    method: 'PATCH',
    body: payload,
  });
}

export async function fetchBakimFiyatOnizleme(params = {}) {
  const query = {};
  if (params.servisKaydiId) query.servisKaydiId = params.servisKaydiId;
  if (params.cihazIds) query.cihazIds = params.cihazIds;
  return apiRequest('/api/bakim-fiyatlari/onizleme', { method: 'GET', query });
}

const PAGE_LIMIT = 100;

export async function fetchAllBakimFiyatlariForCategory(kategoriId, { arama, kategoriAgaciDahil = false } = {}) {
  let page = 1;
  const aggregated = [];
  while (true) {
    const res = await fetchBakimFiyatlari({
      kategoriId,
      arama: arama || undefined,
      kategoriAgaciDahil: kategoriAgaciDahil || undefined,
      sayfa: page,
      limit: PAGE_LIMIT,
    });
    const chunk = res?.veri?.kayitlar || [];
    aggregated.push(...chunk);
    const pagination = res?.veri?.sayfalama || {};
    const toplam = pagination.toplam ?? aggregated.length;
    if (chunk.length < PAGE_LIMIT || aggregated.length >= toplam) break;
    page += 1;
    if (page > 250) break;
  }
  return aggregated;
}
